import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'pcln-design-system'
import { BestPriceGuaranteeCard, ModalHandler } from '@pcln/fly-ui-components'
import { ModalHeader } from 'pcln-modal'

const StyledIFrame = styled.iframe`
  height: 760px;
  padding: 10px;
  width: 100%;

  ${props => props.theme.flyQueries.desktop} {
    width: 760px;
  }
`

class BestPriceGuarantee extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      showBPGOverlay: props.showBPGOverlay,
    }
  }

  setOverlayVisibility = (isVisible = false) => {
    this.setState({
      showBPGOverlay: isVisible,
    })
  }

  showOverlay = () => this.setOverlayVisibility(true)

  render() {
    const iframeUrl =
      'https://www.priceline.com/landing/best-price-guarantee.htm?&lrdr=secure'

    return (
      <div>
        {this.state.showBPGOverlay && (
          <ModalHandler
            width='760px'
            imgMode={true}
            isStatic
            disableCloseButton
            onClose={this.setOverlayVisibility}
            header={<ModalHeader title={'Best Price Guarantee'} />}
          >
            <StyledIFrame src={iframeUrl} />
          </ModalHandler>
        )}
        <Box mb={'24px'}>
          <BestPriceGuaranteeCard
            whenClicked={this.showOverlay}
            ariaLabel='Best Price Guaranteed Information'
          />
        </Box>
      </div>
    )
  }
}

BestPriceGuarantee.defaultProps = {
  showBPGOverlay: false,
}

BestPriceGuarantee.propTypes = {
  showBPGOverlay: PropTypes.bool,
}

export { BestPriceGuarantee }
